import React, { useEffect, useState } from 'react';
import { useReadOnly } from 'slate-react';
import { getNodeChild, PlateRenderElementProps } from '@udecode/plate-core';
import { Edit } from '@styled-icons/feather';
import { CollectionElement, CollectionItemElement as CollectionItemElementType, DreamValue } from '@typedream/core';
import { useRouter } from 'next/router';
import styled from 'styled-components';
import { CollectionItemElement } from '@typedream/components';
import ButtonBoxBorder from '../Button/ButtonBoxBorder';
import { getTPlugin, useTPlateEditorRef } from '../../../../plate';
import { CollectionItemPluginOptions, ICollectionEditor, ICollectionPageData } from '../../types';
import { ELEMENT_COLLECTION_ITEM } from '../../../../pluginKeys';

const EditOverlay = styled.div`
  position: absolute;
  background: linear-gradient(rgba(25, 20, 63, 0),rgba(25, 20, 63,0.5)) ;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    top: 0px;
    left: 0px;
    opacity: 0;
    padding: 10px;
    transition: 0.3s all;
    border-radius: 5px;
`;

const GridItemWrapper = styled.div<{ children:JSX.Element | JSX.Element[] }>`
  position: relative;
  &:hover ${EditOverlay} {
    opacity: 1;
  }
`;
function CollectionElementItem(props: PlateRenderElementProps<DreamValue>) {
  const {
    element, children, attributes,
  } = props;
  const readOnly = useReadOnly();
  const editor = useTPlateEditorRef();
  const router = useRouter();
  const { options } = getTPlugin<CollectionItemPluginOptions>(editor, ELEMENT_COLLECTION_ITEM);

  const [height, setheight] = useState('auto');
  useEffect(() => {
    const child = getNodeChild(element, 0);
    setheight(child ? child.height as string : 'auto');
  }, [element]);

  const itemID = element?.collection_item_id;
  const itemPageID = element?.collection_item_page_id as CollectionElement;
  const { space } = options as CollectionItemPluginOptions;
  const goToPage = (_itemID: string) => {
    router.push(`/col/${space?.slug}/${space.id}/${itemPageID}/${_itemID}`);
  };

  const e = editor as ICollectionEditor;
  useEffect(() => {
    e.setspaceCollectionData?.(space?.customization?.collection_item_data as ICollectionPageData);
  }, [editor, space?.customization?.collection_item_data]);

  useEffect(() => {
    e.setspaceRoutes?.(space?.routes);
  }, [editor, space?.routes]);

  if (readOnly) {
    return <div style={{ height: 'auto', minHeight: height }}>{children}</div>;
  }
  return (
    <GridItemWrapper
      style={{
        height: 'auto',
        minHeight: height,
      }}
      {...attributes}
      data-testid="CollectionElement_gridItemContainer"
    >
      <div
        style={{
          height: '100%',
          pointerEvents: readOnly ? undefined : 'none',
        }}
      >
        <CollectionItemElement element={element as CollectionItemElementType} className={`slate-${element.type}`}>
          {children}
        </CollectionItemElement>
      </div>
      {itemPageID && (
      <EditOverlay>
        <ButtonBoxBorder
          onClick={() => goToPage(itemID as string)}
        >
          <Edit size={25} className="mr-2" />
          Edit Item
        </ButtonBoxBorder>
      </EditOverlay>
      )}
    </GridItemWrapper>
  );
}

export default CollectionElementItem;
